<mat-form-field appearance="fill">
    <input [placeholder]="'vendors.Insert Location' | translate " #inputField matInput />
    <span matSuffix class="grey-color px-2 cursor_pointer" *ngIf="inputField.value"
        (click)="inputField.value=''">
        <mat-icon>close</mat-icon>
    </span>
</mat-form-field>